module.exports = __webpack_public_path__ + "img/kefu.83253b48.png";